import { Injectable } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { collection, doc, getDoc } from 'firebase/firestore';
import { Category } from '..';

@Injectable({
  providedIn: 'root',
})
export class UtilsFirebaseService {
  private readonly ref = collection(this.firestore, 'static-data');
  constructor(private firestore: Firestore) {}

  /**
   * Get the list of currencies
   *
   * @returns The sorted list of supported currencies from firestore
   */
  public async getAvailableLanguages(): Promise<string[]> {
    const docRef = doc(this.ref, 'currencies');
    const data = await getDoc(docRef);
    return data
      .data()
      .supported.sort((a: string, b: string) =>
        a < b ? -1 : 1
      ) as Array<string>;
  }

  /**
   * Get the list of default categories FR
   *
   * @returns The sorted list of supported categories from firestore
   */
  public async getDefaultCategories() {
    const docRef = doc(this.ref, 'categories');
    const data = await getDoc(docRef);
    return Object.values(data.data()['fr-default'][0]).sort(
      (a: Category, b: Category) => (a.label < b.label ? -1 : 1)
    ) as Array<Category>;
  }
}
